import gsap from '@ptchr/gsap/all';

export const customHeaderAnimation = {
	name: 'customHeaderAnimation',
	params: {
		customHeaderAnimation: false
	},
	on: {
		init: function (swiper) {
			if (!swiper.params.customHeaderAnimation) return;
			const tl = gsap.timeline()
			tl.fromTo(this.slides[this.activeIndex].querySelector('.title-wrapper'), {
				autoAlpha: 0,
				y: 100
			}, {
				autoAlpha: 1,
				y: 0
			})
			tl.fromTo(this.slides[this.activeIndex].querySelector('.content'), {
				autoAlpha: 0
			}, {
				autoAlpha: 1
			}, '+=0.25')
		},
		slideChange: function (swiper) {
			if (!swiper.params.customHeaderAnimation) return;
			swiper.$wrapperEl[0].setAttribute('data-current-slide', swiper.realIndex)
		},
		slideChangeTransitionEnd: function (swiper) {
			if (!swiper.params.customHeaderAnimation) return;
			const slide = this.slides[this.activeIndex]
			const tl = gsap.timeline()
			tl.fromTo(slide.querySelector('.title-wrapper'), {
				autoAlpha: 0,
				y: 100
			}, {
				autoAlpha: 1,
				y: 0
			})
			tl.fromTo(slide.querySelector('.content'), {
				autoAlpha: 0
			}, {
				autoAlpha: 1
			}, '+=0.25')
		},
		transitionStart: function (swiper) {
			if (!swiper.params.customHeaderAnimation) return;
			const slide = this.slides[this.previousIndex]

			gsap.to(slide.querySelector('.title-wrapper'), {
				autoAlpha: 0
			})
			gsap.to(slide.querySelector('.content'), {
				autoAlpha: 0
			})
		}
	}
};



// WEBPACK FOOTER //
// ./js/modules/slideshow/effect-custom-header.js